import { useEffect, useState } from "react";
import Packky from "../assets/Packky.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollTop = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", updateScrollProgress);
    return () => window.removeEventListener("scroll", updateScrollProgress);
  }, []);

  return (
    <div className="footer-container " >
      <footer className="footer text-dark position-relative ">
        <div className="container h-100">
          <div className="row ">
            <div className="col-md-4">
              <Link className="d-flex justify-content-start" to="/">
                <img
                  src={Packky}
                  alt="Logo"
                  className="img-fluid mt-4"
                  style={{ maxWidth: "150px", height: "auto" }}
                />
              </Link>
              <p className="card-text text-start fs-5 mt-3">
                Order anything and track it in real time with the Packky (powered by Chaafo) app
              </p>
            </div>
            
       
            <div className="col-md-4 mt-4 p-2 d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column text-start">
                <Link
                  to="/about-us"
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  About Us
                </Link>
                <Link
                  to="/contact-us"
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Contact Us
                </Link>
                <Link
                  to="/term-condition"
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Term & Condition
                </Link>
                <Link
                  to="/privacy-policy"
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/delete-account"
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Delete Account
                </Link>
                <Link
                  to="/blog-section"
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Blog
                </Link>
              </div>
            </div>

            <div className="col-md-4 d-flex justify-content-md-end justify-content-center mt-3">
              <div className="social-icons mt-5 d-flex">
                <Link
                  to="https://www.instagram.com/packkyofficials/"
                  className="me-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram fs-2"></i>
                </Link>

                <Link
                  to="https://www.facebook.com/"
                  className="me-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f fs-2"></i>
                </Link>

                <Link
                  to="https://x.com/Packkyofficials"
                  className="me-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-twitter fs-2"></i>
                </Link>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center">
            <p className="card-text text-center fs-6 ">
              Packky (powered by Chaafo) © 2024 . All rights reserved.
            </p>
          </div>

          <Link
            to="/"
            className="btn btn-black rounded-circle aero-btn position-fixed d-flex justify-content-center align-items-center progress-circle"
            style={{
              bottom: "15px",
              right: "20px",
              width: "50px",
              height: "50px",
              zIndex: "1000",
              "--progress": `${scrollProgress}%`,
            }}
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <i className="fa-solid fa-arrow-up fs-3"></i>
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Footer;

